var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:{ mobile: _vm.$isMobile }},[_c('router-view'),_c('ModalContainer'),_c('DialogContainer'),_c('TooltipContainer'),(_vm.$showTour || (_vm.getIsNewUser && _vm.getShowTour))?_c('TourContainer'):_vm._e(),_c('CookieConsent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }